/**
 * defa.views.RecipienEmailCreateForm
 * A Form for creating email recipients.
 * @version 1.0.0
 */

import Form     from '../../poppet/form';
import template from '../notifications/template-recipient-email-create-form.jst.html';

const selectors = {
	inputEmail               : '[data-input=recipient-email]',
	inputEmailGeneralAlerts  : '[data-input=recipient-email-general-alerts]',
	inputEmailEmergencyAlerts: '[data-input=recipient-email-emergency-alerts]',
	stopEditButton             : '[data-click=recipient-edit-cancel]'
};

export const RecipientEmailCreateForm = Form.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	template,
	noInitValidation: true,
	ui: {
		inputEmail               : selectors.inputEmail,
		inputEmailGeneralAlerts  : selectors.inputEmailGeneralAlerts,
		inputEmailEmergencyAlerts: selectors.inputEmailEmergencyAlerts,
		cancelEdit               : selectors.cancelButton
	},
	
	templateContext: function(){
		return{
			email : this.model.get('recipient') || '',
			emergencyLevel: this.model.get('emergencyLevel') || '',
			generalLevel : this.model.get('generalLevel') || '',
		}
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Validates the email input which disables/enables the save button
	 * Triggers when the user inputs something into the input field.
	 * @void
	 */
	validate: function(){
		let currentEmail = this.ui.inputEmail.val().trim();
		return currentEmail !== ''
	},
	
	/**
	 * Triggers when a user clicks the save button.
	 * Submits the form.
	 * @void
	 */
	submit() {
		let form = {
			recipient : this.ui.inputEmail.val().trim(),
			emergencyLevel : this.ui.inputEmailEmergencyAlerts.is( ':checked' ),
			generalLevel : this.ui.inputEmailGeneralAlerts.is( ':checked' ),
		};
		this.model.set(form);
		this.saveEmailRecipient();
	},
	
	/**
	 * Saves a recipient model to backend.
	 * @void
	 */
	saveEmailRecipient: function(){
		let self = this;
		self.busy();
		try {
			self.model.save( {}, {
				success: function () {
					console.log( 'Recipient Model was saved!' );
					self.idle();
					self.trigger('close', self);
				},
				error  : function () {
					alert( 'failed syncing' );
					console.error( 'Recipient Model failed at saving...' );
					self.idle();
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
			self.model.revertModel();
		}
	},
} );
export default RecipientEmailCreateForm;